import "./headerProtected.css";
import logoBosch from "../../assets/svgs/Bosch_symbol_logo_black_red.svg";
import lineBosch from "../../assets/img/line-header.png";
import Profile from "../profile/profile";


type HeaderProtectedTab = {
  id: string;
  label: string;
  disabled?: boolean;
};

type HeaderProtectedProps = {
  tabs?: HeaderProtectedTab[];
  activeTab?: string;
  onTabChange?: (tabId: string) => void;
};

const headerProtected = ({
  tabs,
  activeTab,
  onTabChange,
}: HeaderProtectedProps) => {
  const hasTabs = !!tabs?.length;

  return (
    <div className="headerProtectedWrapper">
      <div className={hasTabs ? "headerProtectedStyle" : "headerProtectedStyle noTabs"}>
        <img className="lineProtectedClass" src={lineBosch} alt="Line colors Bosch" />
        <div className="ContainerInfosLoginProtected">
          <h1 className="textHeaderProtected">Technical Report Artificial Intelligence</h1>
          <h1 className="textResponsiveProtected">TRAI</h1>
          <div className="containerLogoProtected">
            <Profile />
            <img className="logoClassProtected" src={logoBosch} alt="Logo Bosch" />
          </div>
        </div>
      </div>
      {hasTabs && activeTab && onTabChange && (
        <div className="headerProtectedTabs" role="tablist" aria-label="Abas de conteúdo">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              type="button"
              role="tab"
              aria-selected={activeTab === tab.id}
              className={
                activeTab === tab.id ? "headerProtectedTab active" : "headerProtectedTab"
              }
              disabled={tab.disabled}
              onClick={() => onTabChange(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>
      )}

    </div>
  );
};
export default headerProtected;
